
import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { WidgetConfiguration } from "../../interfaces/widgetConfiguration";
import { WidgetState } from "../../interfaces/widgetState";
import { WidgetPayload } from "../../interfaces/widgetPayload";

@Component
export default class WidgetBase<
    TConfig extends WidgetConfiguration<TState, TPayload>,
    TState = TConfig extends WidgetConfiguration<infer _TState, WidgetPayload>
        ? _TState
        : WidgetState,
    TPayload = TConfig extends WidgetConfiguration<WidgetState, infer _TPayload>
        ? _TPayload
        : WidgetPayload
> extends Vue {
    @Prop() config!: TConfig;
    @Emit() update(event: { config: TConfig; payload: TPayload }) {
        return event;
    }

    public static static: boolean = false;

    public resize() {
        return;
    }

    public static get type(): string {
        throw new Error("not Implemented - Overwrite this in implementation");
    }

    public static get thumbnailAsset(): string {
        throw new Error(
            'not Implemented - Overwrite this with "return require(path/to/asset);"'
        );
    }
}
